"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M18.507 20H5.493A1.494 1.494 0 014 18.507V5.493C4 4.67 4.669 4 5.493 4h13.014C19.33 4 20 4.669 20 5.493v13.014C20 19.33 19.331 20 18.507 20zM6.413 12.8H12.8v-1.6H6.413v1.6zM16.8 7.2H6.413v1.6H16.8V7.2zm0 8H6.413v1.6H16.8v-1.6z" }), "Details");
//# sourceMappingURL=Details.js.map